module.exports = __webpack_public_path__ + "static/media/slider2.c5d18270.jpg";